import { useEffect } from 'react';
import { trackChangeTrackingPointEvent } from '~/analytics/eventTracker';
import { ChooseSubscriptionPage } from '../choose-subscription/ChooseSubscriptionPage';
import { useBasket } from './useBasket';
import { useTitle } from '~/hooks/useTitle';
import { useInternetFlowStore } from '../internet/useInternetStore';

export const SelectSubscription: React.FC = () => {
  useTitle('Velg abonnement', true);
  const resetBasketAfterCheckout = useBasket((s) => s.resetBasketAfterCheckout);

  const dwellingUnit = useBasket((s) => s.dwellingUnit);
  const partnerAlias = useBasket((s) => s.partnerAlias);

  useEffect(() => {
    // In flow v1 the customer filter is step 1
    trackChangeTrackingPointEvent({ trackingPoint: 1, funnelVersion: 2 });
    resetBasketAfterCheckout({ useBasketV2: true });
    // reset internet flow
    useInternetFlowStore.getState().resetState();
  }, [resetBasketAfterCheckout]);

  return <ChooseSubscriptionPage partnerAlias={partnerAlias} dwellingUnit={dwellingUnit} />;
};
